// src/components/Seo.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

const Seo = () => {
  return (
    <Helmet>
      <title>
        HFA Digital Creations | Digital Marketing & Website Development Company
      </title>
      <meta
        name="description"
        content="HFA Digital Creations is a results-driven digital marketing and website development company helping businesses generate more leads, sales, and brand visibility with ROI-focused strategies."
      />
      <meta
        name="keywords"
        content="digital marketing services, website development company, lead generation agency, branding and creative services, HFA Digital Creations"
      />
      <meta name="robots" content="index,follow" />
      <meta property="og:title" content="HFA Digital Creations | Lead Generation Digital Agency" />
      <meta
        property="og:description"
        content="Partner with HFA Digital Creations to grow your leads, sales, and brand presence through digital marketing, websites, apps, and creative content."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://hfadigitalcreations.com" />
      <meta property="og:locale" content="en_IN" />
      <link rel="canonical" href="https://hfadigitalcreations.com" />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LocalBusiness',
          name: 'HFA Digital Creations',
          url: 'https://hfadigitalcreations.com',
          description:
            'Digital marketing, website & app development, branding, graphic design, and video editing services that help businesses grow online.',
          address: {
            '@type': 'PostalAddress',
            addressCountry: 'IN',
            addressRegion: 'Tamil Nadu',
          },
          areaServed: 'IN',
          sameAs: [
            'https://www.instagram.com/hfa_digital_creations/',
            'https://www.facebook.com/61567419236677/',
          ],
          serviceType: [
            'Digital Marketing Services',
            'Website Development',
            'App Development',
            'Branding & Graphic Design',
            'Video Editing',
          ],
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'HFA Digital Creations',
          aggregateRating: {
            '@type': 'AggregateRating',
            ratingValue: '4.9',
            reviewCount: '37',
          },
        })}
      </script>
    </Helmet>
  );
};

export default Seo;
